import React from 'react';
import BetaLink from '../../beta/BetaLink';

const Button = ({
  variant = 'filled',
  children,
  href,
  onClick,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-block px-8 py-3 font-medium text-sm tracking-wide transition-colors rounded';

  const variants = {
    filled: 'bg-primary-red text-white hover:bg-primary-red-dark',
    outlined: 'border-2 border-primary-red text-primary-red hover:bg-primary-red hover:text-white'
  };

  const combinedStyles = `${baseStyles} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <BetaLink to={href} className={combinedStyles} {...props}>
        {children}
      </BetaLink>
    );
  }

  return (
    <button onClick={onClick} className={combinedStyles} {...props}>
      {children}
    </button>
  );
};

export default Button;
